export const FOOTER_HEIGHT = '2.75rem';
export const CROSS_RED = '#CC0000';
